<script setup>
import ArtistOptions from '@components/artist/artist-options'

defineProps({
    artist: {
        type: Object,
        default: () => {},
    },
    hasTypeTitle: {
        type: Boolean,
        default: false,
    },
    isOnSelectMode: {
        type: Boolean,
        default: false,
    },
    isSelected: {
        type: Boolean,
        default: false,
    },
})
</script>

<template>
    <div class="artist-tile">
        <BaseLink
            class="link"
            :to="{ path: isOnSelectMode ? '' : `/artist/${artist.url}/${artist.id}` }"
        >
            <div>
                <div class="inner">
                    <div
                        class="image-container"
                        :class="{ 'is-selected': isSelected }"
                    >
                        <BaseResourceImage
                            :resource="artist"
                            class="image"
                            :width="150"
                            :height="150"
                            type="photo"
                        />
                    </div>
                    <div
                        v-if="!isOnSelectMode"
                        class="options"
                        @click.prevent="() => {}"
                    >
                        <ArtistOptions :artist="artist" />
                    </div>
                </div>
                <BasePlaceholder
                    class="title"
                    :text="artist.title"
                    type="artist"
                    tag="div"
                />
                <div
                    v-if="hasTypeTitle"
                    class="type-title"
                >Artist</div>
            </div>
        </BaseLink>
    </div>
</template>

<style lang="scss" scoped>
@use 'sass:math';
@use '@design' as *;


.link {
    display: block;
}

.inner {
    position: relative;
}

.image-container {
    border: 2px solid transparent;
    border-radius: 50%;

    &.is-selected {
        border-color: $c-accent-default;
    }
}

.image {
    position: relative;
    overflow: hidden;
    background: $c-classics-channel-grad;
    border-radius: 50%;

    &::after {
        @include fill;

        content: '';
        background: $c-surface-raised;
        border-radius: 50%;
        opacity: 0;

        @include transition(opacity, slow);
    }
}

.options {
    @include center;

    z-index: $layer-dropdown-z-index;
    pointer-events: none;

    @include transition(opacity, slow);
}

.title {
    @extend %contentTitleM;

    margin-top: $size-grid-padding;
}

.artist-tile {
    @include square(160px);

    max-width: none;
    padding: $size-grid-padding;
    margin: 0 0 $s-xl;
    text-align: center;

    &:hover {
        .image::after {
            opacity: 0.5;

            @include transition(opacity, base);
        }

        .options {
            pointer-events: visible;
            opacity: 1;

            @include transition(opacity, base);
        }
    }
}

.type-title {
    @extend %contentTitleM;

    margin-top: $s-s;
    text-align: center;
}

@include desktop {
    .title {
        margin-top: $size-large-grid-padding;
    }

    .options {
        opacity: 0;
    }
}
</style>
